import React, { Component, PropTypes } from 'react'
import { Metrics, Fonts } from '../../Themes'
import styled from 'styled-components'
import Grid, { Third } from 'grid-styled'
import Dropdown from '../Dropdown'
import RangePicker from '../RangePicker'
import Button from '../Button'
import {
  searchContinents,
  searchCountries,
  searchCities
} from '../../sources/SearchSource'
import SearchableDropdown from '../SearchableDropdown'
import MultiSelectDropdown from '../MultiSelectDropdown'
import ThemeContainer from '../../components/ThemeContainer'
import {
  maxPrice,
  maxRooms,
  maxYield,
  defaultPriceStep,
  defaultRoomsStep,
  defaultYieldStep
} from '../../Utils/Constants'

const MoreFiltersContainer = styled.div`
  height: calc(100vh - ${Metrics.components.navbarDefault});
  width: ${props =>
    props.isAdminPage
      ? `calc(100vw - ${Metrics.components.sidebar})`
      : '100vw'};
  z-index: -1;
`

var Container = styled.div`
  margin-top: calc(${Metrics.components.searchbar} + ${Metrics.margins.big});
  z-index: 3;
  position: absolute;
  width: 100%;
`

var FormGroup = styled.div`
  min-height: 130px;
  height: auto;
  margin-bottom: ${Metrics.margins.small};
`

var CustomGrid = styled(Grid)`
  padding: 0;
`

const CustomThird = styled(Third)`
  padding-left: ${Metrics.margins.small};
  padding-right: ${Metrics.margins.small};
`

const Title = styled.div`
  ${Fonts.style.Label};
  margin-bottom: ${Metrics.margins.small};
`

const ClearFilters = styled(Button)`
  marginRight: ${Metrics.margins.base};
`

class MoreFilters extends Component {
  constructor (props) {
    super(props)
    this.state = {
      searchCountry: '',
      searchContinent: '',
      searchCity: '',
      countries: [],
      continents: [],
      cities: []
    }

    this.handleSearch = this.handleSearch.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSearch (key, search) {
    switch (key) {
      case 'country':
        searchCountries({ where: { name: { startsWith: search } } })
          .then(response => {
            this.setState({ searchCountry: search, countries: response.data })
          })
          .catch(error => {
            console.log(error)
          })
        break
      case 'continent':
        searchContinents({ where: { name: { startsWith: search } } })
          .then(response => {
            this.setState({
              searchContinent: search,
              continents: response.data
            })
          })
          .catch(error => {
            console.log(error)
          })
        break
      case 'city':
        searchCities({ where: { city: { startsWith: search } } })
          .then(response => {
            this.setState({ searchCity: search, cities: response.data })
          })
          .catch(error => {
            console.log(error)
          })
        break
      default:
        return
    }
  }

  handleSelect (type, value) {
    this.props.handleSelect(type, value)
    this.setState({
      searchCountry: '',
      searchContinent: '',
      searchCity: ''
    })
  }

  render () {
    const {
      settings,
      handleDropdownSelect,
      handleRange,
      handleSelect,
      isAdminPage,
      t,
      categories
    } = this.props

    const {
      cities,
      countries,
      continents,
      searchCategory,
      searchContinent,
      searchCountry,
      searchCity
    } = this.state

    return (
      <MoreFiltersContainer isAdminPage={isAdminPage}>
        <Container>
          <ThemeContainer>
            <CustomGrid>
              <CustomThird>
                <FormGroup>
                  <Title>{t('Type of Asset')}</Title>
                  <MultiSelectDropdown
                    options={categories}
                    showTags
                    selectedOptions={settings.preferredCategories}
                    value={searchCategory}
                    handleSelect={value => {
                      handleSelect('preferredCategories', value)
                    }}
                    placeholder={'Filter By Type of Asset'}
                    accessor={d => d.name}
                    tagsAccessor={d => d.name}
                  />
                </FormGroup>
              </CustomThird>

              <CustomThird>
                <FormGroup>
                  <Title>{t('Portfolio')}</Title>
                  <Dropdown
                    options={[ true, false ]}
                    accessor={d => (d ? 'Yes' : 'No')}
                    selectedOption={settings.portfolio}
                    handleSelect={el => handleDropdownSelect('portfolio', el)}
                    placeholder={'Filter By Portfolio'}
                  />
                </FormGroup>
              </CustomThird>

              <CustomThird>
                <FormGroup>
                  <Title>{t('Continent')}</Title>
                  <SearchableDropdown
                    showTags
                    selectedOptions={settings.preferredRegions}
                    options={continents}
                    value={searchContinent}
                    handleSearch={event => {
                      this.handleSearch('continent', event.target.value)
                    }}
                    handleSelect={value => {
                      this.handleSelect('preferredRegions', value)
                    }}
                    placeholder={'Filter By Continent'}
                    accessor={d => d.name}
                    tagsAccessor={d => d.name}
                  />
                </FormGroup>
              </CustomThird>
            </CustomGrid>
            <CustomGrid>
              <CustomThird>
                <FormGroup>
                  <Title>{t('Country')}</Title>
                  <SearchableDropdown
                    options={countries}
                    selectedOptions={settings.preferredCountries}
                    showTags
                    value={searchCountry}
                    handleSearch={event => {
                      this.handleSearch('country', event.target.value)
                    }}
                    handleSelect={value => {
                      this.handleSelect('preferredCountries', value)
                    }}
                    placeholder={'Filter By Country'}
                    accessor={d => d.name}
                    tagsAccessor={d => d.name}
                  />
                </FormGroup>
              </CustomThird>

              <CustomThird>
                <FormGroup>
                  <Title>{t('City')}</Title>
                  <SearchableDropdown
                    options={cities}
                    value={searchCity}
                    showTags
                    selectedOptions={settings.preferredCities}
                    handleSearch={event => {
                      this.handleSearch('city', event.target.value)
                    }}
                    handleSelect={value => {
                      this.handleSelect('preferredCities', value)
                    }}
                    placeholder={'Filter By City'}
                    accessor={d => d.city}
                    tagsAccessor={d => d.city}
                  />
                </FormGroup>
              </CustomThird>

              <CustomThird>
                <FormGroup>
                  <Title>{t('Number of Keys')}</Title>
                  <RangePicker
                    max={maxRooms}
                    minValue={settings.minNoRooms}
                    maxValue={settings.maxNoRooms}
                    handleChange={value =>
                      handleRange('minNoRooms', 'maxNoRooms', value)}
                    step={defaultRoomsStep}
                  />
                </FormGroup>
              </CustomThird>
            </CustomGrid>
            <CustomGrid>
              <CustomThird>
                <FormGroup>
                  <Title>{t('Estimated Yield')}</Title>
                  <RangePicker
                    max={maxYield}
                    step={defaultYieldStep}
                    minValue={settings.minYield}
                    maxValue={settings.maxYield}
                    unit={'%'}
                    rightUnit
                    handleChange={value =>
                      handleRange('minYield', 'maxYield', value)}
                  />
                </FormGroup>
              </CustomThird>

              <CustomThird>
                <FormGroup>
                  <Title>{t('Price')}</Title>
                  <RangePicker
                    max={maxPrice}
                    step={defaultPriceStep}
                    minValue={settings.minInvestment}
                    maxValue={settings.maxInvestment}
                    unit={'€'}
                    handleChange={value =>
                      handleRange('minInvestment', 'maxInvestment', value)}
                  />
                </FormGroup>
              </CustomThird>
            </CustomGrid>
            <Grid
              style={{ marginTop: Metrics.margins.large, textAlign: 'right' }}>
              <ClearFilters
                secondary
                onClick={this.props.clearFilters}
                label={'Clear all filters'}
              />
              <Button onClick={this.props.apply} label={'Apply'} />
            </Grid>
          </ThemeContainer>
        </Container>
      </MoreFiltersContainer>
    )
  }
}

MoreFilters.propTypes = {
  settings: PropTypes.object,
  handleRange: PropTypes.func,
  handleSelect: PropTypes.func,
  categories: PropTypes.array,
  apply: PropTypes.func,
  t: PropTypes.func,
  handleDropdownSelect: PropTypes.func,
  clearFilters: PropTypes.func,
  isAdminPage: PropTypes.bool
}

export default MoreFilters



// WEBPACK FOOTER //
// ./src/components/SearchBar/MoreFilters.js